import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { useCustomFormats } from "hooks/useCustomFormat";
import { Entity } from "@common/entities/entity.model";
import { DataTableRowActions } from "components/elements/Datatable/data-table-row-actions";
import { ThCheckbox } from "components/elements/Datatable/data-table-th-checkbox";
import { TdCheckbox } from "components/elements/Datatable/data-table-td-checkbox";
import { ThSorter } from "components/elements/Datatable/data-table-th-sorter";
import { DataTableRowSkeleton } from "components/elements/Datatable/data-table-row-skeleton";
import { Link } from "react-router-dom";
import { ThActions } from "components/elements/Datatable/data-table-th-actions";

export function EntitiesTable() {
  const { formatDate, formatDateTime } = useCustomFormats();
  const { data: result, isFetching, modal } = useResource<Entity>();

  return (
    <Table variant="simple">
      <Thead>
        <Tr>
          <ThCheckbox />
          <ThSorter field="name">Entity Name</ThSorter>
          <ThSorter field="address">Entity Address</ThSorter>
          <ThSorter field="established_date" w="115px">
            Established
          </ThSorter>
          <ThSorter field="created_at" w="150px">
            Created At
          </ThSorter>
          <ThActions />
        </Tr>
      </Thead>
      <Tbody>
        {isFetching ? (
          <DataTableRowSkeleton columns={6} rows={5} />
        ) : (
          result.data.map(entity => (
            <Tr key={entity.id} onClick={() => modal.handleOpenModal(entity)} cursor="pointer">
              <TdCheckbox entity={entity} />
              <Td>
                <Link
                  to={`/companies/${entity.company}/entities/${entity.id}`}
                  onClick={e => e.stopPropagation()}
                >
                  {entity.name}
                </Link>
              </Td>
              <Td>{entity.address}</Td>
              <Td>{formatDate(entity.established_date)}</Td>
              <Td>{formatDateTime(entity.created_at)}</Td>
              <Td onClick={e => e.stopPropagation()}>
                <DataTableRowActions item={entity} />
              </Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
}
